<template>
  <el-dialog
      :title="action === 'edit' ? '编辑' : '添加'"
      :visible="show"
      @close="closeDialog"
      :close-on-click-modal="false"
      width="680px"
      :modal-append-to-body="false"
  >
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item :label="$t('text.cardGroupName')" prop="groupName" :label-width="formLabelWidth">
        <el-input :placeholder="$t('message.inputRemark')" v-model="form.groupName"/>
      </el-form-item>
      <el-form-item :label="$t('text.remark')" prop="remark" :label-width="formLabelWidth">
        <el-input type="textarea" :placeholder="$t('message.inputRemark')" v-model="form.remark"/>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('text.cancel') }}</el-button>
      <el-button type="primary" @click="saveSystem"
      >{{ $t('text.confirm') }}
      </el-button>
    </div>
  </el-dialog>


</template>

<script>

import vueJsonEditor from 'vue-json-editor';

export default {
  name: "channelEdit",
  props: {
    show: Boolean,
    multipleSelection: {
      type: [Object, Array], // 支持 Object 或 Array
      required: false
    },
    action: String,
  },
  components: {
    vueJsonEditor,
  },
  data() {
    return {
      formLabelWidth: "100px",
      form: {
        groupId: "",
        groupName: "",
        remark: "",
        sysId:"-1",
      },
      rules: {
        groupName: [
          {
            required: true,
            message: this.$t('message.inputCardGroupName'),
            trigger: ["blur", "change"]
          }
        ],
      }
    };
  },
  created() {
    if (this.action === 'edit') {
      this.form = this.multipleSelection
    }
  },
  methods: {
    closeDialog() {
      // this.$refs["form2"].resetFields(); //关闭的时候重置表单
      this.$emit("update:show", false);
    },
    saveSystem() {
      this.form.groupId = Number(this.form.groupId)
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.action === "edit") {
            const params = {
              groupId: this.form.groupId,
              groupName: this.form.groupName,
              remark: this.form.remark,
              sysId: this.form.sysId,
            }
            this.axios.put("/card-group/updateCardGroup", params).then((res) => {
              if (res.code === 200) {
                this.$notify({
                  title: this.$t('text.prompt'),
                  message: res.msg,
                  type: "success"
                });
                this.$bus.$emit("refresh"); //通知刷新

                this.closeDialog();
                this.$emit('refresh-upstream-list');
                this.$emit('refresh');
                this.$emit('refresh-list');
              } else {
                this.$notify.error({
                  title: this.$t('text.prompt'),
                  message: res.msg
                });
              }
            });
          } else {
            this.axios.post("/card-group/addCardGroup", this.form).then((res) => {
              if (res.code === 200) {
                this.$notify({
                  title: this.$t('text.prompt'),
                  message: res.msg,
                  type: "success"
                });
                // this.$bus.$emit("refresh"); //通知刷新
                this.$emit('refresh-list');

                this.closeDialog();
                this.$emit('refresh-upstream-list');
              } else {
                this.$notify.error({
                  title: this.$t('text.prompt'),
                  message: res.msg
                });
              }
            });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.el-select {
  width: 100%;
}
</style>
